<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h4 class="m-0 text-dark">Return Order of <b>{{ merchant_business }}</b></h4>
                         <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div>
                    <div class="col-md-2">
                        <div class="form-group" style="margin-top:28px;">
                            <button class="ml-1 btn btn-success btn-sm mr-2" @click="pdfDownload">PDF <i class="fa fa-download"></i></button>
                            <button class="btn btn-warning btn-sm" >                                            
                                <export-excel
                                    :data="dataCustomize"
                                    :fields= "json_fields"
                                    >
                                    Excel <i class="fa fa-download"></i>
                                </export-excel>
                            </button>
                        </div>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table id="exportPdfTableHeader" class="table table-bordered" style="display:none">
                                            <thead>
                                                <tr>
                                                    <td>Merchant: {{ merchant_business }}</td>
                                                    <td style="text-align:right">Total Order: {{ orders.length }}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                        <table id="exportPdfTable" class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Deadline</th>
                                                    <th>Customer</th>
                                                    <th>Price (BDT)</th>
                                                    <th>Collected (BDT)</th>
                                                    <th>Service Charge</th>
                                                    <th>Return Charge</th>
                                                    <th>Area Charge</th>
                                                    <th>Weight Charge</th>
                                                    <th>COD</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(order, index) in orders" :key="index">
                                                    <td>{{ order.id }}</td>
                                                    <td @click="orderLog(order.id)">{{ order.date | dateformat }}</td>
                                                    <td>{{ order.name }}<br/>{{ order.mobile }}</td>
                                                    <td>{{ order.price }}</td>
                                                    <td>{{ order.collected }}</td>
                                                    <td>{{ order.service_charge }}</td>
                                                    <td>{{ order.return_charge }}</td>
                                                    <td>{{ order.area_charge }}</td>
                                                    <td>{{ order.weight_charge }}</td>
                                                    <td>{{ order.cod }}</td>
                                                    <td>{{ order.amount }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <!-- /.content -->
        <div v-if="orderLogModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Order Log</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered table-sm">
                            <tr>
                                <th>Action By</th>
                                <th>Action</th>
                                <th>Date & Time</th>
                            </tr>
                            <tr v-for="(log, index) in order_logs" :key="index">
                                <td>{{ log.user_name }}</td>
                                <td>{{ log.operation }}</td>
                                <td>{{ log.date | dateformat }} at {{ log.date | timeformat }}</td>
                            </tr>
                        </table>                      
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    // import jsPDF from 'jspdf'
    import 'jspdf-autotable'    
    import ExportPdf from './Pdf'

    const excelColumn = {
        'Order ID': 'order_id',
        'SKU': 'order_sku',
        'Reference ID': 'order_reference_id',
        'Customer': 'order_customer',
        'Price': 'order_price',
        'Collected': 'order_collected',
        'Service Charge': 'order_service_charge',
        'Return Charge': 'order_return_charge',
        'Area Charge': 'order_area_charge',
        'Weight Charge': 'order_weight_charge',
        'COD': 'order_cod',
        'Amount': 'order_amount'
    }
    export default {
        name:'MakePaymentOrder',
        data(){
            return {   
                orderLogModal:false,
                order_logs:[],
                loader: true,             
                orders:[],
                key:'',
                merchant_business: '',
            }
        },
        created(){
            this.getOrders();
        },
        computed: {
            json_fields: function () {
                return excelColumn
            },
            dataCustomize () {
                return this.orders.map(item => {
                    item.order_id = item.id,
                    item.order_sku = item.sku,
                    item.order_reference_id= item.reference_id,
                    item.order_customer = item.name +" "+item.mobile,
                    item.order_price= item.price,
                    item.order_collected= item.collected,
                    item.order_service_charge= item.service_charge,
                    item.order_return_charge= item.return_charge,
                    item.order_area_charge= item.area_charge,
                    item.order_weight_charge= item.weight_charge,
                    item.order_cod= item.cod,
                    item.order_amount= item.amount

                    return Object.assign({}, item)
                })
            }
        },
        methods:{
            searchData () {
                this.getOrders()
            },
            async getOrders(){     
                this.loader = true     
                const response = await config.getData(`/hub/return/details/${this.$route.query.id}`)
                this.loader = false
                if (response.success){
                    this.orders = response.data
                    this.merchant_business = response.merchant
                } else {
                    this.orders = []
                    this.merchant_business = ''
                } 
            },
            pdfDownload() {
                // this.loader = true
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                ExportPdf.returnPdfDetails(base64Logo, this.orders, this.merchant_business)
                // this.loader = false
            },
            getBase64Logo (logo) {
                var canvas = document.createElement('canvas')
                canvas.width = logo.width
                canvas.height = logo.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(logo, 0, 0)
                var dataURL = canvas.toDataURL('image/png')
                return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
            },
            orderLog (orderId) {
                config.getData('/order/order-log/'+ orderId)
                .then((response) => {
                    this.orderLogModal = true
                    this.order_logs = response.data;   
                });
            },
            cancelModal () {
                this.orderLogModal = false
            }
        }
    }
</script>

<style scoped>
    .d-inline {
        display: inline-block;
        padding-left: 3px;
    }
</style>